import React, { useState } from 'react';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { useResponsive } from '@app/hooks/useResponsive';
import * as S from './ProfileDropdown.styles';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseAvatar } from '@app/components/common/BaseAvatar/BaseAvatar';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { HeaderActionWrapper } from '@app/components/header/Header.styles';
import { BaseModal } from '@app/components/common/BaseModal/BaseModal';
import { BasePopover } from '@app/components/common/BasePopover/BasePopover';
import { ProfileOverlay } from '../ProfileOverlay/ProfileOverlay';
import { NotificationsDropdown } from '../../notificationsDropdown/NotificationsDropdown';

export const ProfileDropdown: React.FC = () => {
  const { isTablet } = useResponsive();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const user = useAppSelector((state) => state.user.user);
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const handleLogout = () => {
    setIsLogoutModalVisible(false);
    navigate('/logout');
  };

  const showLogoutModal = () => {
    setIsLogoutModalVisible(true);
  };

  const cancelLogout = () => {
    setIsLogoutModalVisible(false);
  };

  return user ? (
    // <BasePopover content={<ProfileOverlay />} trigger="click">
    // </BasePopover>
      <S.ProfileDropdownHeader as={BaseRow} gutter={[10, 10]} align="middle">
      {isTablet && (
        <>
        
          <BasePopover content={<ProfileOverlay />} trigger="click">
            <BaseCol>
              <BaseAvatar>
                <UserOutlined />
              </BaseAvatar>
            </BaseCol>
            <BaseCol>
              <span className="username">{`${user.firstName}`}</span>
            </BaseCol>
          </BasePopover>
          <BaseCol>
          <HeaderActionWrapper>
            <BaseButton className='logout' type="text" icon={<LogoutOutlined />} onClick={showLogoutModal} />
          </HeaderActionWrapper>
          </BaseCol>
        </>
      )}
      <BaseModal
        title={t('logout.logoutConfirmationTitle')}
        visible={isLogoutModalVisible}
        onOk={handleLogout}
        onCancel={cancelLogout}
        okText={t('logout.confirm')}
        cancelText={t('logout.cancel')}
      >
        <p>{t('logout.logoutConfirmationMessage')}</p>
      </BaseModal>
    </S.ProfileDropdownHeader>
  ) : null;
};
